import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa0da376"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa0da376')) {
      api.createRecord('aa0da376', component.options)
    } else {
      api.reload('aa0da376', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aa0da376", function () {
      api.rerender('aa0da376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/authorityManage/index.vue"
export default component.exports